module.exports = __webpack_public_path__ + "img/bufu-logo-load.4325e585.png";